import { IMemberProfile } from '../interfaces/iMemberProfile'
import { ICause } from '../interfaces/iCause'
import { IGeneralInfoOfMember } from '../interfaces/iGeneralInfoOfMember'
import { ILocation } from '../interfaces/iLocation'
import { ICompany } from '../interfaces/iCompany'
import { INetwork } from "../interfaces/iNetwork";
import { ISchool } from "../interfaces/ISchool";
import { IPhilanthropy } from "../interfaces/IPhilanthropy";
import { ICurrentPositions } from "../interfaces/ICurrentPositions";
import { INonprofit } from "../interfaces/iNonprofit";
import { IMetropolitanArea } from "../interfaces/iMetropolitanArea";
import { IKeyName } from "../interfaces/IKeyName";
import { GeneralInfoOfMember } from "./generalInfoOfMember";
import { IOpportunity } from '../interfaces/nonprofitProfile/iOpportunity';

export class MemberProfile implements IMemberProfile {
    isMyProfile: boolean = false;
    philanthropy: IPhilanthropy[] = [];
    currentPositions: ICurrentPositions[] = [];
	generalInfo: IGeneralInfoOfMember = new GeneralInfoOfMember();
	locations: ILocation[] = [];
    metropolitanAreas: IMetropolitanArea[] = [];
    filterMetropolitanAreas: IMetropolitanArea[] = [];
	causes: ICause[] = [];
    companies: ICompany[] = [];
    network: INetwork;
    schools: ISchool[] = [];
    subtypOpportunitiesList: IKeyName[];
    eventTypes: IKeyName[];
    prefTypes: IKeyName[];
    shortlistOpportunitiesList: IOpportunity[];
    certificationVisibility: boolean;

    constructor(memberProfile: IMemberProfile = {} as IMemberProfile) {
        this.isMyProfile = memberProfile.isMyProfile;
		this.generalInfo = memberProfile.generalInfo;
		this.locations = memberProfile.locations;
        this.metropolitanAreas = memberProfile.metropolitanAreas;
        this.filterMetropolitanAreas = memberProfile.filterMetropolitanAreas;
        this.causes = memberProfile.causes;
        this.companies = memberProfile.companies;
        this.network = memberProfile.network;
        this.schools = memberProfile.schools;
        this.philanthropy = memberProfile.philanthropy;
        this.currentPositions = memberProfile.currentPositions;
        this.subtypOpportunitiesList = memberProfile.subtypOpportunitiesList;
        this.eventTypes = memberProfile.eventTypes;
        this.prefTypes = memberProfile.prefTypes;
        this.shortlistOpportunitiesList = memberProfile.shortlistOpportunitiesList;
        this.certificationVisibility = memberProfile.certificationVisibility;
	}
    
    
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/memberProfile.ts